
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ToDoMasterDialog extends Serenity.EntityDialog<ToDoMasterRow, any> {
        protected getFormKey() { return ToDoMasterForm.formKey; }
        protected getIdProperty() { return ToDoMasterRow.idProperty; }
        protected getLocalTextPrefix() { return ToDoMasterRow.localTextPrefix; }
        protected getNameProperty() { return ToDoMasterRow.nameProperty; }
        protected getService() { return ToDoMasterService.baseUrl; }

        protected form = new ToDoMasterForm(this.idPrefix);

    }
}